/**
 * The shared hero-preset gallery — objects under booking-pages/presets/ in the
 * public media bucket. Keep in sync with what's actually uploaded there
 * (an entry whose object is missing renders a broken thumbnail).
 * Sources: Adobe Stock extended licenses (piano/guitar/violin/stage,
 * purchased 2026-08-10) + Unsplash (free license), curated 2026-08-10.
 */
export interface HeroPreset {
  url: string;
  /** For the picker's alt text / tooltip only. */
  topic: string;
}

const PRESET_BASE_URL =
  "https://timeplanned-media.s3.eu-central-1.amazonaws.com/booking-pages/presets";

const preset = (file: string, topic: string): HeroPreset => ({
  url: `${PRESET_BASE_URL}/${file}`,
  topic,
});

export const HERO_PRESETS: HeroPreset[] = [
  preset("piano-1.webp", "Piano"),
  preset("guitar-1.webp", "Guitar"),
  preset("violin-1.webp", "Violin"),
  preset("stage-1.webp", "Stage spotlight"),
  preset("stage-2.webp", "Concert lights"),
  preset("books-1.webp", "Books"),
  preset("books-2.webp", "Study desk"),
  preset("map-1.webp", "World map"),
  preset("crayons-1.webp", "Crayons"),
  preset("gym-1.webp", "Dumbbells"),
  preset("gym-2.webp", "Gym"),
  preset("yoga-1.webp", "Yoga studio"),
  preset("yoga-2.webp", "Wellness studio"),
  preset("ballet-1.webp", "Ballet"),
  preset("martial-2.webp", "Martial arts"),
  preset("swim-1.webp", "Swimming pool"),
  preset("tennis-1.webp", "Tennis courts"),
  preset("art-1.webp", "Watercolors"),
  preset("watercolor-1.webp", "Watercolor wash"),
  preset("cooking-1.webp", "Baking"),
  preset("neutral-1.webp", "Gradient"),
  preset("neutral-2.webp", "Purple waves"),
  preset("mountain-1.webp", "Mountains at dusk"),
];
